import { KeenIcon } from '@/components';
import { toAbsoluteUrl } from '@/utils';
import { FormattedMessage } from 'react-intl';

// Logo and flag file names come from the session's browser, platform and
// location. A value the server could not work out must not break the page,
// which is where a firm that requires 2FA sends its staff (OL-157).
const asKey = (value) => String(value || 'unknown').toLowerCase();
const hideIfMissing = (event) => { event.currentTarget.style.display = 'none'; };

const TrustedDevices = ({ data, loading, deleteSession, deleteAllSessions, isLoading }) => {
  const renderItem = (item, index) => {
    return (
      <tr key={index}>
        <td className="min-w-48 w-48">
          <div className="flex items-center gitem gap-2.5">
            <img src={toAbsoluteUrl(`/media/brand-logos/${asKey(item.browser)}.svg`)} onError={hideIfMissing} className="h-6" alt={item.browser} />
            <div className="flex flex-col">
              <div className="text-sm font-medium text-gray-900 mb-px">
                {item.browser}
              </div>
              <div className="flex gap-1.5">
                <span className="text-xs text-gray-700">{item.location}</span>
                <img src={toAbsoluteUrl(`/media/flags/${asKey(item.location)}.svg`)} onError={hideIfMissing} className="h-3.5 rounded-full" alt="image" />
                {/* Here you can replace with a flag for the location if required */}
              </div>
            </div>
          </div>
        </td>

        <td className="min-w-56 text-gray-700 font-normal">
          {item.device}
          <br />
          {item.last_used_at}
        </td>

        <td className="min-w-56 text-gray-700 font-normal">
          <div className="flex items-center gitem gap-2.5">
            <img src={toAbsoluteUrl(`/media/brand-logos/${asKey(item.platform)}.svg`)} onError={hideIfMissing} className="h-4" alt={item.platform} />
            <div className="flex flex-col">
              <div className="text-sm font-medium text-gray-900 mb-px">
                {item.platform}
              </div>
              <div className="flex gap-1.5">
                <span className="text-xs text-gray-700"><FormattedMessage id="login_sessions.ip" /> {item.ip_address}</span>
              </div>
            </div>
          </div>
        </td>

        <td className="min-w-56 text-gray-700 font-normal">
          <span className={`badge badge-sm badge-outline ${item.is_active ? 'badge-success' : 'badge'}`}>
            {item.is_active ? <FormattedMessage id="login_sessions.active_session" /> : <FormattedMessage id="login_sessions.inactive_session" />}
          </span>
          <br />
          <div className="mt-1">
            <span className={`text-xs font-medium ${item.is_current ? 'text-green-500' : 'text-gray-500'}`}>
              {item.is_current ? <FormattedMessage id="login_sessions.active_on_this_device" /> : <FormattedMessage id="login_sessions.active_on_another_device" />}
            </span>
          </div>
        </td>

        <td className="!pr-7.5 min-w-16 text-end">
          {!item.is_current &&
            <button onClick={() => { deleteSession(item.id) }} className="btn btn-sm btn-icon btn-light btn-clear">
              <KeenIcon icon="exit-right" />
            </button>
          }
        </td>
      </tr>
    );
  };

  return (
    <div className="card min-w-full mb-4">
      <div className="card-header">
        <h3 className="card-title"><FormattedMessage id="login_sessions" /></h3>

        {data && Object.keys(data).length > 1 ? (
          <button className='text-xs btn btn-sm btn-danger btn-outline'
            disabled={isLoading}
            onClick={() => { deleteAllSessions() }}>
            {isLoading ? <FormattedMessage id="USER.MENU.PLEASE_WAIT" /> : <FormattedMessage id="login_sessions.delete_all_sessions" />}
          </button>
        ) : ''}
      </div>

      <div className="card-table scrollable-x-auto">
        <div className="scrollable-auto">
          <table className="table align-middle text-gray-600 font-medium text-2sm">
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center text-gray-500">
                    <div className="loader"><FormattedMessage id="user_profile.loading" /></div>
                  </td>
                </tr>
              ) : data && Object.keys(data).length > 0 ? (
                Object.values(data).map((item, index) => renderItem(item, index))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center text-gray-500">
                    <FormattedMessage id="login_sessions.no_trusted_devices_found" />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};
export { TrustedDevices };